import { Breadcrumbs, makeStyles, Typography } from '@material-ui/core';
import { Link } from '@reach/router';
import React from 'react';

import { FontSizes } from '../../../../core/config/mainTheme';
import { toCssValue } from '../../../../core/utils/theme.utils';

interface OwnProps {
  items: BreadCrumbLink[];
}

export interface BreadCrumbLink {
  text?: string;
  path?: string;
}

const ThemeBreadcrumbs: React.FC<OwnProps & { children?: React.ReactNode }> = ({
  items,
  children,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.breadcrumbWrapper}>
      <Breadcrumbs separator="›" aria-label="breadcrumb" className={classes.breadcrumb}>
        {items.map((item: BreadCrumbLink, index: number) => {
          if (item.path) {
            return (
              <Link key={index} to={item.path}>
                {item.text}
              </Link>
            );
          } else {
            return <Typography key={index}>{item.text}</Typography>;
          }
        })}
      </Breadcrumbs>
      {children}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  breadcrumbWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  breadcrumb: {
    padding: toCssValue([theme.spacing(0), theme.spacing(6)]),
    '& .MuiTypography-root': {
      fontSize: FontSizes.size.headerSize,
    },
  },
}));

export default ThemeBreadcrumbs;
